import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from './user';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(sessionStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  login(username: string, password: string): Observable<any> {
    const data = { username: username, password: password };

    return this.http.post<User>(environment.gatewayEndpoints.auth + '/login', data).pipe(
      map(user => {
        // Check if token and username exists
        if (user && user.id_token) {
          // Save token
          this.storeAuthenticationToken(user);
          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }

  loginSSO(tokenSSO: string): Observable<any> {
    //Añadimos esto por un error en el commit anterior. Fecha -> 05072022 - Ricardo Jimenez Hurtado
    if ((this.currentUserSubject) && (this.currentUserSubject.value) && (this.currentUserSubject.value.username)){
      //console.log('authservice - loginsso - logout');
      this.logout(this.currentUserSubject.value.username);
    }

    const headerSSO = {
      AuthorizationSSO: tokenSSO,
      'X-Skip-Interceptor-Auth': 'X-Skip-Interceptor-Auth'
    };

    const requestOptions = {
      headers: new HttpHeaders(headerSSO)
    };

    return this.http
      .get<User>(environment.gatewayEndpoints.auth + `/login/sso/${tokenSSO}`, requestOptions)
      .pipe(
        map(user => {
          // Check if token and username exists
          if (user && user.id_token) {
            // Save token
            this.storeAuthenticationToken(user);
            this.currentUserSubject.next(user);
          }
          return user;
        })
      );
  }

  refreshLogin(): Observable<any> {
    const id_token = sessionStorage.getItem('authenticationToken');
    return this.http
      .post<User>(environment.gatewayEndpoints.auth + '/login/refresh', id_token)
      .pipe(
        map(user => {
          // Check if token and username exists
          if (user && user.id_token) {
            // Save token
            this.storeAuthenticationToken(user);
            this.currentUserSubject.next(user);
          }
          return user;
        })
      );
  }

  logout(username: string) {
    //console.log('auth.service - logout ' + username);
    if (username) {
      return this.http.post<string>(environment.gatewayEndpoints.auth + '/log-out', username).pipe(tap(() => {
        this.removeAuthenticationToken();
        this.currentUserSubject.next(null);
      }));
    }
  }

  /**
   * Save authentication token into local storage
   * @param jwt token to save in JWT format with key token
   */
  private storeAuthenticationToken(user: User) {
    sessionStorage.setItem('currentUser', JSON.stringify(user));
    sessionStorage.setItem('authenticationToken', user.id_token);
  }

  /**
   * Remove authentication token from local storage
   */
  private removeAuthenticationToken() {
    sessionStorage.removeItem('currentUser');
    sessionStorage.removeItem('authenticationToken');
    document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'JSESSIONID=; Path=/api/authentication; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //console.log('auth.service - logout - cookie: ', document.cookie);
  }
}
